const Form080TC = {
    stepName: {
        importantNotes: "重要事項",
        studentInfo: "學生資料",
        schoolUse: "學校資料",
        confirmation: "確認頁",
    },
    title: {
        t1: "需要用戶輸入的表單字段",
        t2: "由校方填寫",
    },
    studentName: "學生姓名",
    schoolName: "學校名稱",
    schoolCode: "學校編號",
    class: "班級",
    birthDate: "出生日期",
    address: "地址",
    tel: "電話號碼",
    strN: "學生編號",
    certificate: "身份證/出生證明書/護照號碼",
    noOption: {
        hkId: "身份證號碼",
        birthNo: "出生證明書號碼",
        passNo: "護照號碼",
    },
    employName: "僱主名稱",
    employAddress: "僱主地址",
    workNature: "工作性質",
    workDate: "工作日期",
    workHours: "工作時間",
    aPOption: {
        am: "上午",
        pm: "下午",
    },
    wages: "工資",
    workSchedule: "相關證明文件（例如工作時間表）",
    date: "日期",

    validCertify: "在學證明書有效期",
    schoolTel: "學校電話",
    schoolAddress: "學校地址",
    classHours: "上課時間",
    schoolChop: "校印",

    from: "由",
    to: "時至",

    sign: {
        parentSign: "家長/監護人簽署",
        parentAtt: "家長/監護人掃描",
        parentEle: "家長/監護人電子簽名",
        parentName: "家長/監護人姓名",

        headSign: "校長簽署",
        headAtt: "校長簽名掃描",
        headEle: "校長電子簽名",
        headName: "校長姓名",
    },
    nameOfSchoolHead: "校長姓名",
    attachment: "校長簽名掃描",
    notes: {
        note: "本人已閲讀、明白及同意上述條款及細則",
        n1: "時",
        n2: "本人擬為小兒/小女/受監護兒童申請在學證明書，以便能於上課時間以外從事工作。 該份工作的詳情如下﹕",
        n3: "本人知悉申請表格及「在學證明書」均不收任何費用。",
        n4: "致 : 教育局局長",
        n5: "[缺課個案專責小組經辦]",
        n6: "傳真: 2520 0073",
        n7: "茲證明上述學生的資料正確，而該生的上學記錄一向令人滿意。根據本人的判斷，上述工作將不會影響其學業表現。",
        n8: "本人擬簽發在學證明書予該生的家長/監護人，該份證明書的有效期由",
        n9: "為止。 請將有關證明書寄交本人，以便簽發。",
        n10: "至",
    },
    wantSubmit: {
        w1: "我想提交這個申請表",
    },

    showPop: "學生已年滿15歲。根據《僱傭條例》，有關申請並不適用。",

    schoolOption: {
        s1: "1",
        s2: "2",
    },

    errorMsg: { minDigit: "此項最少需要填寫{{min}}個數字" },
};
export default Form080TC;
